
import React, { createContext, useState, useEffect } from 'react';

// Définir la forme du contexte
export const OrderHoursContext = createContext({
  isOpen: true,
  message: '',
  checkOrderHours: () => ({ isOpen: true, message: '' }),
});

// Fournisseur du contexte
export const OrderHoursProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [message, setMessage] = useState('');

  // Définir les horaires (exemple : 12:00–15:00, 18:00–20:00)
  const hours = [
    { open: '12:00', close: '15:00' }, // Créneau du matin
    { open: '18:00', close: '23:00' }, // Créneau du soir
  ];

  // Définir le numéro de téléphone
  const phoneNumber = '03 23 64 01 67'; // Votre numéro

  // Valider le format des heures
  const validateTime = (time) => {
    const regex = /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/;
    return regex.test(time);
  };

  // Vérifier les horaires au montage
  useEffect(() => {
    hours.forEach((slot) => {
      if (!validateTime(slot.open) || !validateTime(slot.close)) {
        console.error('[OrderHours] Format d’heure invalide :', slot);
      }
    });
  }, []);

  const checkOrderHours = () => {
    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes(); // Heure en minutes
    const today = now.getDay(); // 0 (dimanche) à 6 (samedi)

    // Convertir "HH:MM" en minutes
    const parseTime = (time) => {
      try {
        const [hours, minutes] = time.split(':').map(Number);
        if (isNaN(hours) || isNaN(minutes)) {
          throw new Error('Format d’heure invalide');
        }
        return hours * 60 + minutes;
      } catch (error) {
        console.error('[OrderHours] Erreur lors de l’analyse de l’heure :', { time, error });
        return 0;
      }
    };

    // Vérifier si ouvert
    let isRestaurantOpen = false;
    let nextOpen = null;
    let currentClose = null;

    for (const slot of hours) {
      const openTime = parseTime(slot.open);
      const closeTime = parseTime(slot.close);
      if (currentTime >= openTime && currentTime < closeTime) {
        isRestaurantOpen = true;
        currentClose = closeTime;
        break;
      }
      if (currentTime < openTime && (!nextOpen || openTime < nextOpen)) {
        nextOpen = openTime;
      }
    }

    // Générer le message
    let statusMessage = '';
    if (isRestaurantOpen && currentClose) {
      // Livraison disponible
      const hours = Math.floor(currentClose / 60);
      const minutes = currentClose % 60;
      statusMessage = `Livraison disponible jusqu’à ${hours}h${minutes.toString().padStart(2, '0')}`;
    } else {
      // Livraison indisponible
      if (nextOpen) {
        // Prochaine ouverture aujourd’hui
        const hours = Math.floor(nextOpen / 60);
        const minutes = nextOpen % 60;
        statusMessage = `Fermé - Nous ouvrons à ${hours}h${minutes.toString().padStart(2, '0')} - Appelez au ${phoneNumber} pour vérifier si nous sommes vraiment fermés avant de passer une commande`;
      } else {
        // Prochaine ouverture demain à 12:00
        statusMessage = `Fermé - Appelez au ${phoneNumber} pour vérifier si nous sommes vraiment fermés avant de passer une commande`;
      }
    }

    console.log('[OrderHours] État :', { isOpen: isRestaurantOpen, message: statusMessage, currentTime, today });
    return { isOpen: isRestaurantOpen, message: statusMessage };
  };

  useEffect(() => {
    const updateHours = () => {
      const { isOpen, message } = checkOrderHours();
      setIsOpen(isOpen);
      setMessage(message);
    };

    updateHours();
    const interval = setInterval(updateHours, 60 * 1000); // Vérifier toutes les minutes
    return () => clearInterval(interval);
  }, []);

  return (
    <OrderHoursContext.Provider value={{ isOpen, message, checkOrderHours }}>
      {children}
    </OrderHoursContext.Provider>
  );
};